// extracted by mini-css-extract-plugin
export default {"base":"vp_jT_6y","editor":"vp_rOk1G"};